import angular from 'angular';

import translationsModuleName from '../../../../../lib/translation';

import serviceModuleName from '../../../../../lib/service';
import adhocModalModule from '../adhocModal';

// Component
import component from './positionsPanel.component';

const moduleName = 'staff.dashboardScreen.positionsPanel';
let module = angular.module(moduleName, [
  translationsModuleName,
  serviceModuleName,
  adhocModalModule.name,
]);

module.component('positionsPanel', component);

export default module;
